import Vue from 'vue/dist/vue.esm'
import i18n from '../vue_plugins/i18n'
import '../vue_plugins/turbolinks'
import '../vue_plugins/vSelect'

componentsToMount = [
  {
    el: 'section#documents',
    components: {
      RemoteToggle: () -> import('../vue_components/remote_toggle/RemoteToggle'),
      NotesViewer: () -> import('../vue_components/notes/NotesViewer'),
      RemoteChoices: () -> import('../vue_components/remote_choices/RemoteChoices'),
      AcademicBackgroundDetail: () -> import('../vue_components/academic_backgrounds/AcademicBackgroundDetail'),
      ReceptionStatusView: () -> import('../vue_components/reception_statuses/Index'),
    }
  },
  {
    el: '#redundant-requests',
    components: {
      RedundantRequestsView: () -> import('../vue_components/redundant_requests/Index'),
    }
  },
  {
    el: '#profile',
    components: {
      AddressesView: () -> import('../vue_components/addresses/Index'),
      PersonPhotoContainer: () -> import('../vue_components/person_photo/PersonPhotoContainer'),
    }
  },
  {
    el: '#disabilities',
    components: {
      DisabilitiesView: () -> import('../vue_components/disabilities/Index'),
    }
  },
  {
    el: '#faqs',
    components: {
      FaqsViewer: () -> import('../vue_components/frequent_questions/FaqsViewer'),
    }
  },
  {
    el: '#offers',
    components: {
      OffersView: () -> import('../vue_components/offers/Index'),
    }
  },
  {
    el: '#announcements',
    components: {
      AnnouncementsView: () -> import('../vue_components/announcements/Index')
    }
  },
  {
    el: '#announcement-detail',
    components: {
      AnnouncementDetail: () -> import('../vue_components/announcements/AnnouncementDetail')
    }
  },
  {
    el: '#academic-backgrounds',
    components: {
      AcademicBackgrounds: () -> import('../vue_components/academic_backgrounds/Index'),
      EmptyState: () -> import('../vue_components/ui/EmptyState'),
    }
  },
  {
    el: '#entrance_requests',
    components: {
      EntranceRequestsViewer: () -> import('../vue_components/entrance_requests/Index'),
    }
  },
  {
    el: '#applicants',
    components: {
      ApplicantsView: () -> import('../vue_components/applicants/Index'),
    }
  },
]

document.addEventListener 'turbolinks:load', () ->
  for { el, components } in componentsToMount
    el = document.querySelector el
    if el?
      new Vue
        el: el
        components: components
        i18n: i18n

$(window).on 'beforeunload', ->
  localStorage.clear()
